import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface User {
  id: string
  username: string
  email: string
  avatar?: string
  role: string
  bio?: string
  location?: string
  website?: string
  followersCount?: number
  followingCount?: number
  canPost?: boolean
  expertType?: string
  expertBio?: string
  notificationSettings?: {
    emailNotifications: boolean
    commentNotifications: boolean
    likeNotifications: boolean
    messageNotifications: boolean
    followNotifications: boolean
  }
}

interface AuthState {
  user: User | null
  isAuthenticated: boolean
  setAuth: (user: User) => void
  logout: () => void
  updateUser: (user: Partial<User>) => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      isAuthenticated: false,
      setAuth: (user) => {
        localStorage.setItem('userData', JSON.stringify(user))
        set({ user, isAuthenticated: true })
      },
      logout: () => {
        localStorage.removeItem('userData')
        set({ user: null, isAuthenticated: false })
      },
      updateUser: (userData) =>
        set((state) => {
          const newUser = state.user ? { ...state.user, ...userData } : null
          if (newUser) {
            localStorage.setItem('userData', JSON.stringify(newUser))
          }
          return { user: newUser }
        }),
    }),
    {
      name: 'auth-storage',
    }
  )
)
